<!--
 * @Description: 优惠明细弹窗
 * @Author: yeqing
 * @Date: 2021-11-10 14:35:30
 * @LastEditTime: 2021-11-24 15:55:13
 * @LastEditors: gjc
-->
<template>
  <div class="offerDetails">
    <div class="title"><span>金额明细</span>*实际优惠金额请以下单页为准</div>
    <div class="item">
      <label>商品总价</label><span>￥{{ total }}</span>
    </div>
    <div class="item">
      <label>优惠金额</label><span>￥{{ discount }}</span>
    </div>
    <div class="item">
      <label>共减</label><span>￥{{ discount > total ? total : discount }}</span>
    </div>
    <div class="item">
      <label>合计</label><span>￥{{ discount >= total ? 0 : total - discount }}</span>
    </div>
    <div class="trangle"></div>
  </div>
</template>
<script>
export default {
  props: {
    total: Number, // 总价
    discount: Number // 优惠金额
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.offerDetails {
  width: 340px;
  height: 245px;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 2px;
  padding: 30px 20px;
  position: relative;
  .title {
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: left;
    margin-bottom: 30px;
    span {
      font-weight: 500;
      color: #333333;
      margin-right: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .item {
    display: flex;
    justify-content: space-between;
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    margin-top: 24px;
    span {
      color: #ff6d33;
    }
  }
  .trangle {
    width: 0px;
    height: 0px;
    border: 9px solid #fff;
    border-top-color: #fff;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    position: absolute;
    bottom: -17px;
    right: 53px;
  }
}
</style>
